import React, { useState } from 'react';
import SignUp from './SignUp';
import ThankYou from './ThankYou';

function Main(props) {

    const getDownloadUrl = () => {
        let name = 'book_download_url';
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return (match) ? match[2] : '';
    }

    const getName = () => {
        let name = 'book_previous_name';;
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return (match) ? match[2] : '';
    }

    const getEmail = () => {
        let name = 'book_previous_email';;
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return (match) ? match[2] : '';
    }

    const getPostalCode = () => {
        let name = 'book_previous_postalCode';
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return (match) ? match[2] : '';
    }

    const [downloadUrl, setDownloadUrl] = useState(getDownloadUrl());

    const [subscribedToBookList, setSubscribedToBookList] = useState(false);


    const [user, setUser] = useState({
        name: getName(),
        email: getEmail(),
        postalCode: getPostalCode(),
        subscribeToMainList: false
    });

    const [formErrors, setFormErrors] = useState({ name: '', email: '', postalCode: '' });
    const [emailValid, setEmailValid] = useState(user.name !== '');
    const [nameValid, setNameValid] = useState(user.email !== '');
    const [postalCodeValid, setPostalCodeValid] = useState(user.postalCode !== '');

    let setCookies = (url) => {
        var expiresTime = new Date();
        var minutes = 15;
        expiresTime.setTime(expiresTime.getTime() + (minutes * 60 * 1000));
        document.cookie = `has_book_access=true;expires=${expiresTime.toUTCString()};domain=${window.location.hostname}`;
        document.cookie = `book_download_url=${url};expires=${expiresTime.toUTCString()};domain=${window.location.hostname}`;

        document.cookie = `book_previous_name=${user.name};expires=${expiresTime.toUTCString()};domain=${window.location.hostname}`;

        document.cookie = `book_previous_email=${user.email};expires=${expiresTime.toUTCString()};domain=${window.location.hostname}`;

        document.cookie = `book_previous_postalCode=${user.postalCode};expires=${expiresTime.toUTCString()};domain=${window.location.hostname}`;
    }

    //function clearCookies() {
    //    document.cookie = 'has_book_access=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //    document.cookie = 'book_download_url=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //    document.cookie = 'book_previous_name=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //    document.cookie = 'book_previous_email=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //    document.cookie = 'book_previous_postalCode=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //    setDownloadUrl('');
    //}

    const subscribe = (listType) => {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', './home/subscribe');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
          if (xhr.status === 200) {
            var data = JSON.parse(xhr.responseText);

            if (listType === 'book') {
                setSubscribedToBookList(true);
            }

            if (data.value !== undefined && data.value.url !== undefined) {
                setCookies(data.value.url);
                setDownloadUrl(data.value.url);
            }
        }
      };
      xhr.send(JSON.stringify({
        "email": user.email,
        "firstName": user.name.split(' ').slice(0, -1).join(' '),
        "lastName": user.name.split(' ').slice(-1).join(' '),
        "postalCode": user.postalCode,
        "shouldSubscribe": listType === 'book' ? true : user.subscribeToMainList,
        "listType": listType
      }));
    }

    const validateField = (fieldName, value) => {
        let fieldValidationErrors = formErrors;
        
        switch (fieldName) {
            case 'name':
                let valid = value.split(" ").length > 1 && value.split(" ")[1] !== '';
                fieldValidationErrors.name = valid ? '' : 'Please enter your full name';
                setNameValid(valid);
                break;
            case 'email':
                let match = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.email = match ? '' : 'Not a valid email';
                setEmailValid(!!match);
                break;
            case 'postalCode':
                let pc_match = value.match(/\w\d\w ?\d\w\d/i);
                fieldValidationErrors.postalCode = pc_match ? '' : 'Must be a valid canadian postal code.';
                setPostalCodeValid(!!pc_match);
                break;
            default:
                break;
        }

       
        setFormErrors(fieldValidationErrors);
    }

    function tryToSignUp(e) {
        subscribe('main');
        e.preventDefault();
    }
  const cloneUser = () => {
    return JSON.parse(JSON.stringify(user));
  }

  const updateUser = (field, value) => {
    let curUser = cloneUser();
    curUser[field] = value;
    setUser(curUser);
    validateField(field, value);
  }

    function renderContent() {
        if (downloadUrl) {
            return <ThankYou user={user} subscribedToBookList={subscribedToBookList} downloadUrl={downloadUrl} updateUser={updateUser} subscribe={subscribe} emailValid={emailValid} formErrors={formErrors} />
    }

        return <SignUp tryToSignUp={tryToSignUp} user={user} updateUser={updateUser} nameValid={nameValid} emailValid={emailValid} postalCodeValid={postalCodeValid} formErrors={formErrors} />
  }

  return (
    <section className="main">
      {renderContent()}
    </section>
  )

}

export default Main;
